import React from 'react';
import Navbar from './homepage/components/Navbar';
import Footer from './homepage/components/Footer';
import HelpCenter from './HelpCenter';
import './HelpCenter.css';

/**
 * Public wrapper for HelpCenter — accessible without login.
 * Uses the homepage Navbar + Footer instead of the sidebar Layout.
 */
export default function PublicHelpPage() {
  return (
    <div className="homepage" style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Navbar />
      <div style={{ paddingTop: 80, paddingBottom: 40, maxWidth: 1100, margin: '0 auto', padding: '100px 24px 60px' }}>
        <HelpCenter />
      </div>
      <Footer />
    </div>
  );
}
